(function($) {

  'use strict';

  function LocationFilter() {

    var self = this,
      $el = null,

      options = {
        example: null,
      };


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }


      // Caching
      //Filtre les résultats de recherche


      // Disabled Neighborhood select if Westmount selected
      $('#selectVille').on('change', function() {
        // console.log('selected :', $('#selectVille').val());

        if ( $('#selectVille').val() == 'Westmount') {
          $('#selectQuartier').attr('disabled', 'disabled');
        } else {
          $('#selectQuartier').removeAttr('disabled');
        }
      });
      

      // *************
      //window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      //onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.LocationFilter = LocationFilter;

}(jQuery));
